import {
    CREATE_PRJASN_START, CREATE_PRJASN_SUCCESS, CREATE_PRJASN_FAILURE,
    FETCH_PRJASN_START, FETCH_PRJASN_SUCCESS, FETCH_PRJASN_FAILURE, SET_PRJASN_INIT, 
    FETCH_PRJ_SUCCESS, FETCH_PRJ_FAILURE, FETCH_PRJ_START, UPDATE_PRJASN_START, UPDATE_PRJASN_SUCCESS, UPDATE_PRJASN_FAILURE
} from "./prjAsnTypes";

export const createPrjAsn = (payload) => (
    {
        type: CREATE_PRJASN_START,
        payload
    }
)

export const createPrjAsnSucc = (payload) => (
    {
        type: CREATE_PRJASN_SUCCESS,
        payload
    }
)

export const createPrjAsnFailure = (payload) => (
    {
        type: CREATE_PRJASN_FAILURE,
        payload
    }
)

export const fetchPrjAsn = () => (
    {
        type: FETCH_PRJASN_START
    }
)

export const fetchPrjAsnFailure = (error) => ({
    type: FETCH_PRJASN_FAILURE,
    error,
});

export const SETPrjAsnInit = (payload) => ({
    type: SET_PRJASN_INIT,
    payload
});

export const fetchPrjAsnSucc = (projectsAsn) => ({
    type: FETCH_PRJASN_SUCCESS,
    projectsAsn
});

export const fetchPrj = () => (
    {
        type: FETCH_PRJ_START
    }
)

export const fetchPrjSucc = (projects) => ({
    type: FETCH_PRJ_SUCCESS,
    projects
});

export const fetchPrjFailure = (error) => ({
    type: FETCH_PRJ_FAILURE,
    error,
});

export const updatePrjAsn = (payload) => ({
    type: UPDATE_PRJASN_START,
    payload,
})

export const updatePrjAsnSucc = (payload) => ({
    type: UPDATE_PRJASN_SUCCESS,
    payload
})

export const updatePrjAsnFailure = (payload) => ({
    type: UPDATE_PRJASN_FAILURE,
    payload
})